import { render, staticRenderFns } from "./StageIndicator.vue?vue&type=template&id=39e6e512&scoped=true&lang=pug&"
import script from "./StageIndicator.vue?vue&type=script&lang=js&"
export * from "./StageIndicator.vue?vue&type=script&lang=js&"
import style0 from "./StageIndicator.vue?vue&type=style&index=0&id=39e6e512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e6e512",
  null
  
)

export default component.exports